/* eslint-disable camelcase */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from './gameData';
import Games from './Games';

/**
 * Fixes the origin/pivot point for all animation frames, and then creates the animations
 * @param {Phaser.Scene} scene 
 */
export function setupAnimations(scene) {
  const mainTex = scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS);
  if (gameData.game === Games.face) {
    fixPivot(mainTex, 'eyes/', FACE_EYE_ANIMATION_DATA.frames);

    for (const key in FACE_EYE_ANIMATION_DATA.animations) {
      const animationData = FACE_EYE_ANIMATION_DATA.animations[key];
      const frames = [];
      animationData.frames.forEach(frameNum => frames.push({ frame: `eyes/${frameNum.toString()}` }));
      scene.anims.create(
        {
          defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
          frameRate: 20,
          key,
          frames
        }
      );
    }
  }
  else if (gameData.game === Games.pumpkin) {
    fixPivot(mainTex, 'eyes/', PUMPKIN_EYES_ANIMATION_DATA.frames);

    for (const key in PUMPKIN_EYES_ANIMATION_DATA.animations) {
      const animationData = PUMPKIN_EYES_ANIMATION_DATA.animations[key];
      const frames = [];
      animationData.frames.forEach(frameNum => frames.push({ frame: `eyes/${frameNum.toString()}` }));
      scene.anims.create(
        {
          defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
          frameRate: 40,
          key,
          frames
        }
      );
    }
  }
  else if (gameData.game === Games.snowman) {
    fixPivot(mainTex, 'eyes/', SNOWMAN_EYES_ANIMATION_DATA.frames);

    for (const key in SNOWMAN_EYES_ANIMATION_DATA.animations) {
      const animationData = SNOWMAN_EYES_ANIMATION_DATA.animations[key];
      const frames = [];
      animationData.frames.forEach(frameNum => frames.push({ frame: `eyes/${frameNum.toString()}` }));
      scene.anims.create(
        {
          defaultTextureKey: ABCyaPhaser.Images.DEFAULT_ATLAS,
          frameRate: 40,
          key,
          frames
        }
      );
    }
  }
}

/**
 * 
 * @param {Phaser.GameObjects.Sprite} sprite 
 */
export function addEyeAnimationsToSprite(sprite) {
  if (gameData.game === Games.face) {
    for (const key in FACE_EYE_ANIMATION_DATA.animations) {
      const animationData = FACE_EYE_ANIMATION_DATA.animations[key];
      if (animationData.next !== null && animationData.next !== undefined) {
        sprite.off(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key);
        sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key, () => {
          sprite.play(animationData.next);
        });
      }
    }
  }
  else if (gameData.game === Games.pumpkin) {
    for (const key in PUMPKIN_EYES_ANIMATION_DATA.animations) {
      const animationData = PUMPKIN_EYES_ANIMATION_DATA.animations[key];
      if (animationData.next !== null && animationData.next !== undefined) {
        sprite.off(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key);
        sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key, () => {
          sprite.play(animationData.next);
        });
      }
    }
  }
  else if (gameData.game === Games.snowman) {
    for (const key in SNOWMAN_EYES_ANIMATION_DATA.animations) {
      const animationData = SNOWMAN_EYES_ANIMATION_DATA.animations[key];
      if (animationData.next !== null && animationData.next !== undefined) {
        sprite.off(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key);
        sprite.on(Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + key, () => {
          sprite.play(animationData.next);
        });
      }
    }
  }
}

/**
 * 
 * @param {Phaser.Textures.Texture} texture 
 * @param {string} prefix 
 * @param {number[][]} frameData 
 */
function fixPivot(texture, prefix, frameData) {
  frameData.forEach((data, index) => {
    const frame = texture.get(prefix + index);
    frame.customPivot = true;
    frame.pivotX = data[5] / data[2];
    frame.pivotY = data[6] / data[3];
  });
}

// this data comes from the original game; this is the CreateJs sprite sheet animation export
const FACE_EYE_ANIMATION_DATA = {
  frames: [
    [254, 2, 256, 83, 0, -2, -2],
    [1083, 188, 256, 1, 0, -2, -43],
    [375, 99, 262, 45, 0, -2, -2],
    [910, 154, 262, 23, 0, -2, -23],
    [400, 188, 262, 1, 0, -2, -45],
    [1642, 154, 262, 4, 0, -2, -42],
    [437, 154, 262, 24, 0, -2, -22],
    [2, 99, 178, 51, 0, -2, -2],
    [666, 188, 178, 1, 0, -2, -27],
    [514, 2, 177, 71, 0, -17, -2],
    [1134, 99, 192, 36, 0, -9, -19],
    [191, 188, 205, 1, 0, -2, -37],
    [237, 154, 196, 25, 0, -7, -25],
    [184, 99, 187, 47, 0, -12, -14],
    [695, 2, 261, 67, 0, -2, -1],
    [1772, 99, 237, 34, 0, -14, -42],
    [899, 99, 231, 36, 0, 0, 0],
    [1330, 99, 231, 36, 0, 0, 0],
    [1837, 2, 197, 62, 0, -6, -2],
    [1423, 2, 201, 62, 0, -4, -2],
    [1216, 2, 203, 63, 0, -3, -2],
    [1628, 2, 205, 62, 0, -2, -3],
    [2, 154, 231, 30, 0, -2, -2],
    [848, 188, 231, 1, 0, -2, -16],
    [1565, 99, 203, 35, 0, -2, -2],
    [703, 154, 203, 24, 0, -2, -13],
    [1176, 154, 204, 13, 0, -1, -24],
    [2, 188, 185, 2, 0, -11, -35],
    [2, 2, 248, 93, 0, -5, -1],
    [960, 2, 252, 65, 0, -3, -16],
    [641, 99, 254, 36, 0, -2, -31],
    [1384, 154, 254, 7, 0, -2, -47]
  ],
  animations: {
    Eyes10: {
      speed: 0.3,
      next: 'Eyes10_idle',
      frames: [24, 24, 25, 26, 27, 27, 27, 26, 25, 24]
    },
    Eyes2_idle: { speed: 0.3, frames: [2] },
    Eyes8_idle: { speed: 0.3, frames: [18] },
    Eyes11_idle: { speed: 0.3, frames: [28] },
    Eyes11: {
      speed: 0.3,
      next: 'Eyes11_idle',
      frames: [28, 28, 29, 30, 31, 31, 31, 31, 30, 29, 28]
    },
    Eyes3_idle: { speed: 0.3, frames: [7] },
    Eyes7_idle: { speed: 0.3, frames: [16] },
    Eyes4: {
      speed: 0.3,
      next: 'Eyes4_idle',
      frames: [9, 9, 10, 11, 11, 11, 12, 13, 9]
    },
    Eyes5: {
      speed: 0.3,
      next: 'Eyes5_idle',
      frames: [14, 15, 15, 15, 15, 14]
    },
    Eyes9_idle: { speed: 0.3, frames: [22] },
    Eyes2: {
      speed: 0.3,
      next: 'Eyes2_idle',
      frames: [2, 2, 3, 4, 4, 5, 6, 2]
    },
    Eyes1: {
      speed: 0.3,
      next: 'Eyes1_idle',
      frames: [0, 1, 1, 1, 0]
    },
    Eyes9: {
      speed: 0.3,
      next: 'Eyes9_idle',
      frames: [22, 23, 23, 23, 23, 22]
    },
    Eyes10_idle: { speed: 0.3, frames: [24] },
    Eyes6_idle: { speed: 0.3, frames: [] },
    Eyes7: {
      speed: 0.3,
      next: 'Eyes7_idle',
      frames: [16, 17, 17, 17, 17, 17, 17, 16]
    },
    Eyes5_idle: { speed: 0.3, frames: [14] },
    Eyes8: {
      speed: 0.3,
      next: 'Eyes8_idle',
      frames: [18, 18, 19, 20, 21, 21, 21, 20, 19, 18]
    },
    Eyes4_idle: { speed: 0.3, frames: [9] },
    Eyes1_idle: { speed: 0.3, frames: [0] },
    Eyes3: {
      speed: 0.3,
      next: 'Eyes3_idle',
      frames: [7, 8, 8, 8, 7, 7]
    }
  }
};

const PUMPKIN_EYES_ANIMATION_DATA = {
  frames: [
    [385, 2, 209, 94, 0, -2, -2],
    [221, 101, 210, 81, 0, -2, -2],
    [443, 346, 210, 69, 0, -2, -2],
    [870, 346, 210, 56, 0, -2, -2],
    [1084, 346, 209, 44, 0, -3, -2],
    [657, 346, 209, 66, 0, -2, -2],
    [661, 269, 211, 73, 0, -1, -2],
    [435, 101, 209, 80, 0, -2, -2],
    [1825, 2, 209, 87, 0, -2, -2],
    [210, 420, 204, 31, 0, -4, -7],
    [2, 420, 204, 32, 0, -4, -6],
    [1687, 346, 202, 35, 0, -5, -4],
    [1483, 346, 200, 38, 0, -6, -2],
    [809, 420, 201, 29, 0, -2, -2],
    [604, 420, 201, 29, 0, -2, -14],
    [193, 2, 188, 95, 0, -17, -1],
    [598, 2, 194, 94, 0, -14, -3],
    [993, 2, 200, 91, 0, -11, -6],
    [1401, 2, 208, 89, 0, -7, -9],
    [2, 101, 215, 85, 0, -4, -13],
    [1613, 2, 208, 89, 0, -8, -9],
    [1197, 2, 200, 91, 0, -12, -6],
    [796, 2, 193, 94, 0, -16, -3],
    [1539, 269, 217, 72, 0, -2, -3],
    [1087, 101, 214, 76, 0, -6, -4],
    [1315, 190, 217, 73, 0, -1, -8],
    [1523, 101, 213, 75, 0, 0, -5],
    [660, 190, 214, 74, 0, 0, -1],
    [440, 190, 216, 75, 0, -1, 0],
    [220, 190, 216, 75, 0, -1, -2],
    [2, 190, 214, 75, 0, 0, -2],
    [223, 269, 213, 73, 0, 0, 0],
    [222, 346, 217, 69, 0, -1, 0],
    [1097, 190, 214, 73, 0, -6, 0],
    [1097, 269, 217, 72, 0, -2, -3],
    [1536, 190, 215, 73, 0, -1, 0],
    [2, 346, 216, 70, 0, -3, 0],
    [1760, 269, 216, 71, 0, -7, 0],
    [648, 101, 215, 76, 0, -9, 0],
    [440, 269, 217, 73, 0, -5, -4],
    [1740, 101, 214, 75, 0, -4, -1],
    [2, 269, 217, 73, 0, -5, 0],
    [867, 101, 216, 76, 0, -8, -1],
    [878, 190, 215, 74, 0, -8, -6],
    [1755, 190, 217, 73, 0, -3, -8],
    [1305, 101, 214, 76, 0, -1, -4],
    [1318, 269, 217, 72, 0, -2, -3],
    [1014, 420, 216, 23, 0, -2, -2],
    [1454, 420, 216, 21, 0, -2, -4],
    [2, 456, 216, 19, 0, -2, -6],
    [442, 456, 216, 17, 0, -2, -8],
    [882, 456, 216, 15, 0, -2, -10],
    [1102, 456, 216, 13, 0, -2, -12],
    [1542, 456, 216, 11, 0, -2, -14],
    [222, 479, 216, 8, 0, -2, -17],
    [442, 479, 216, 6, 0, -2, -19],
    [880, 479, 212, 4, 0, -4, -21],
    [1096, 479, 196, 3, 0, -12, -22],
    [662, 479, 214, 5, 0, -3, -20],
    [2, 479, 216, 8, 0, -2, -17],
    [1762, 456, 216, 11, 0, -2, -14],
    [1322, 456, 216, 13, 0, -2, -12],
    [662, 456, 216, 16, 0, -2, -9],
    [222, 456, 216, 19, 0, -2, -6],
    [1234, 420, 216, 22, 0, -2, -3],
    [1297, 346, 182, 38, 0, -2, -2],
    [418, 420, 182, 29, 0, -2, -7],
    [1674, 420, 182, 20, 0, -2, -11],
    [1860, 420, 183, 10, 0, -1, -16],
    [1296, 479, 182, 2, 0, -2, -20],
    [2, 2, 187, 95, 0, -17, -1],
    [876, 269, 217, 73, 0, -3, -3]
  ],
  animations: {
    Eyes3_idle: { speed: 1, frames: [13] },
    Eyes7: {
      speed: 1,
      next: 'Eyes7_idle',
      frames: [65, 66, 67, 68, 69, 69, 69, 69, 68, 67, 66, 65]
    },
    Eyes7_idle: { speed: 1, frames: [65] },
    Eyes6: {
      speed: 1,
      next: 'Eyes6_idle',
      frames: [
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        57,
        57,
        57,
        57,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        47
      ]
    },
    Eyes4_width: { speed: 1, next: 'Eyes4_width', frames: [19] },
    Eyes2: {
      speed: 1,
      next: 'Eyes2_idle',
      frames: [9, 10, 11, 12, 12, 12, 12, 11, 10, 9]
    },
    Eyes1: {
      speed: 1,
      next: 'Eyes1_idle',
      frames: [0, 1, 2, 3, 4, 4, 4, 4, 5, 6, 7, 8, 0]
    },
    Eyes3: {
      speed: 1,
      next: 'Eyes3_idle',
      frames: [13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 14, 14, 13]
    },
    Eyes2_idle: { speed: 1, frames: [9] },
    Eyes1_idle: { speed: 1, frames: [0] },
    Eyes5: {
      speed: 1,
      next: 'Eyes5_idle',
      frames: [
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46
      ]
    },
    Eyes4: {
      speed: 1,
      next: 'Eyes4_idle',
      frames: [15, 15, 16, 17, 18, 19, 19, 19, 19, 20, 21, 22, 15]
    },
    Eyes6_idle: { speed: 1, frames: [47] },
    Eyes5_idle: { speed: 1, frames: [71] },
    Eyes4_idle: { speed: 1, frames: [70] }
  }
};

const SNOWMAN_EYES_ANIMATION_DATA = {
  frames: [
    [520, 2, 79, 11, 0, -2, -2],
    [765, 2, 0, 0, 0, 0, 0],
    [255, 2, 88, 18, 0, -2, -2],
    [428, 2, 88, 11, 0, -2, -5],
    [174, 2, 77, 21, 0, -2, -2],
    [347, 2, 77, 15, 0, -2, -5],
    [603, 2, 77, 8, 0, -2, -8],
    [684, 2, 77, 1, 0, -2, -12],
    [88, 2, 82, 25, 0, -1, -1],
    [2, 2, 82, 25, 0, -1, -1]
  ],
  animations: {
    Eyes3_idle: { speed: 0.8, frames: [4] },
    Eyes2_idle: { speed: 0.8, frames: [2] },
    Eyes3: {
      speed: 0.8,
      frames: [4, 5, 6, 7, 7, 7, 7, 6, 5, 4],
      next: 'Eyes3_idle'
    },
    Eyes6_idle: { speed: 0.8, frames: [8] },
    Eyes1_idle: { speed: 0.8, frames: [0] },
    Eyes1: {
      speed: 0.8,
      frames: [0, 0, 1, 1, 0, 0, 0],
      next: 'Eyes1_idle'
    },
    Eyes6: {
      speed: 0.8,
      frames: [8, 8, 9, 9, 9, 9, 9, 8, 8, 8],
      next: 'Eyes6_idle'
    },
    Eyes2: {
      speed: 0.8,
      frames: [2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2],
      next: 'Eyes2_idle'
    }
  }
};